import { render, staticRenderFns } from "./MotoristaCreate.vue?vue&type=template&id=b7d4e7a8&"
import script from "./MotoristaCreate.vue?vue&type=script&lang=js&"
export * from "./MotoristaCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports